export default __webpack_public_path__ + "747b97c12501e28f872c35634ca2fe1c.png";